































import { Actions } from '@/ts/store/Constants';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ProfileImage extends Vue {
    @Prop() public userId: number;
    @Prop() public imageType: string;
    @Prop() public size: string;
    @Prop() public borderRadius: string;
    @Prop({ default: 'img' }) public wrapper: string;
    @Prop({ default: false }) public showInitials: boolean;
    @Prop({ default: '' }) public initials: string;

    constructor() {
        super();
    }

    get profileImage() {
        return this.$store.getters['Images/getUserProfileImage'](this.userId);
    }

    get hasProfileImage() {
        return (this.profileImage !== '' && typeof this.profileImage !== 'undefined');
    }

    public created() {
        if (!this.hasProfileImage) {
            this.$store.dispatch(Actions.FETCH_USER_PROFILE_IMAGE, { userId: this.userId, type: this.imageType });
        }
    }
}
